import React, {
  Component
  // , Fragment
} from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';
import { withRouter } from 'react-router';
import OuterBox from '../OuterBox/OuterBox';
import InnerBox from '../InnerBox/InnerBox';
// import ArticleList from '../ArticleList/ArticleList';
import SearchList from './SearchList';
import { SideBar } from '../StyledComponents/StyledSideBar';
import SearchBarFull from './SearchBarFull';
// import { FlexContainer } from '../StyledComponents/FlexContainer';
// import { apiEndpoints } from '../../../config/config';
// import axios from 'axios';
import AdBanner from '../AdBanner/AdBanner';
import adAmazonVertical from '../../../assets/images/ad-amazon-vertical.png';

import {
  // Title,
  // StyledLine,
  // StyledLineInside,
  // ListElement,
  Image,
  FlexContainer
} from '../StyledComponents';
import List_S_Image from '../ListWithImage/List_S_Image';

class Search extends Component {
  state = {
    searchResultList: null
  };
  componentDidMount = () => {
    let query = this.props.match.params.query.split(' ').join('%20');
    // console.log('query: ', query.split(' ').join('%20'));
    // console.log('Search CDM');
    this.props.onFetchTopResults(query, 1);
    this.props.onFetchTopReviews();
    // console.log('this.props: ', this.props);
    // let url = `${apiEndpoints.searchInput}/results/${
    //   this.props.match.params.query
    // }`;
    // console.log('url: ', url);
    // axios.get(url).then(response => {
    //   console.log('response: ', response);
    //   this.setState({ searchResultList: response.data.searchResults });
    // });
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('prevProps: ', prevProps);
    // console.log('this.props: ', this.props);
    let query = this.props.match.params.query.split(' ').join('%20');
    // console.log('query: ', query.split(' ').join('%20'));
    // console.log('Search CDM');
    if (query !== prevProps.match.params.query.split(' ').join('%20'))
      this.props.onFetchTopResults(query, 1);
  };

  handlePageChange = page => {
    let query = this.props.match.params.query.split(' ').join('%20');
    this.props.onFetchTopResults(query, page);
  };

  navigateAndIncreasePostCount = postSlug => {
    // console.log('postId: ', postId);
    // console.log('postSlug: ', postSlug);
    // this.props.onIncreasePostCount(postId);
    this.navigate(postSlug);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    const dataForArticleList = {
      limit: 1,
      pageCount: 8,
      total: 18,
      currentPage: 1
    };

    return (
      <FlexContainer
        className="flex-column"
        style={{
          width: '100%',
          maxWidth: '1040px',
          // height: '8rem',
          marginTop: '1rem'
        }}
      >
        <SearchBarFull />

        <OuterBox>
          <InnerBox>
            <SearchList
              className="ArticleList NewsList"
              title="Top Results"
              data={dataForArticleList}
              contentData={this.props.topResults}
              handlePageChange={this.handlePageChange}
              clicked={this.navigateAndIncreasePostCount}
            />
            <SideBar>
              <AdBanner height="600px" width="300px" margin="0 0 14px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              {/* {this.props.topReviewsForSearch ? ( */}
              {
                // eslint-disable-next-line
                <List_S_Image
                  title="Top Reviews"
                  listItems={this.props.topReviewsForSearch}
                />
              }
              {/* ) : null} */}
            </SideBar>
          </InnerBox>
        </OuterBox>
      </FlexContainer>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state.search: ', state.search);
  return {
    loading: state.news.loading,
    // bannerData: state.news.bannerData,
    // recentNews: state.news.recentNews,
    // trendingTags: state.news.trendingTags,
    // topNews: state.news.topNews,
    topResults: state.search.topResults,
    topReviewsForSearch: state.search.topReviewsForSearch
  };
};

const mapDispatchToProps = dispatch => ({
  // onFetchBanner: () => dispatch(Creators.fetchBanner()),
  onFetchTopResults: (query, page) =>
    dispatch(Creators.fetchTopResults(query, page)),
  onFetchTopReviews: () => dispatch(Creators.fetchTopReviewsForSearch())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Search));
